import { create } from "zustand";

interface FilterState {
  filters: Record<string, any>;
  setFilters: (filters: FilterState["filters"]) => void;
  resetFilters: () => void;
}

const defaultFilters: FilterState["filters"] = {
  "employee.name": { value: "", matchMode: "contains" },
  projectRole: { value: "", matchMode: "contains" },
  status: { value: "", matchMode: "contains" },
};

export const useFilterProjectMemberProjectStore = create<FilterState>((set) => ({
  filters: defaultFilters,
  setFilters: (filters) => set({ filters }),
  resetFilters: () => set({ filters: defaultFilters }),
}));
